/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Statistics`)
};

const es_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a Estadísticas`)
};

const de_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Statistiken`)
};

const nl_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar statistieken`)
};

const fr_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour aux statistiques`)
};

const it_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alle statistiche`)
};

const pt_br2_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar às estatísticas`)
};

const pt_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar às estatísticas`)
};

const ja_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統計に戻る`)
};

const zh_f1_profile_back_to_stats = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回统计`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_back_to_stats = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_back_to_stats(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_back_to_stats", locale)
	if (locale === "en") return en_f1_profile_back_to_stats(inputs)
	if (locale === "es") return es_f1_profile_back_to_stats(inputs)
	if (locale === "de") return de_f1_profile_back_to_stats(inputs)
	if (locale === "nl") return nl_f1_profile_back_to_stats(inputs)
	if (locale === "fr") return fr_f1_profile_back_to_stats(inputs)
	if (locale === "it") return it_f1_profile_back_to_stats(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_back_to_stats(inputs)
	if (locale === "pt") return pt_f1_profile_back_to_stats(inputs)
	if (locale === "ja") return ja_f1_profile_back_to_stats(inputs)
	return zh_f1_profile_back_to_stats(inputs)
};